import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

import { IdentityDetails } from '../../../../../../consumer/graphql/fragments/identity';

export const getAccountAlbumFolderSubscribedIdentitiesQuery = gql`
  query getAccountAlbumFolderSubscribedIdentities(
    $albumFolderIds: [RecordID] = []
  ) {
    me {
      id
      subscribed_album_folder_identities(
        album_folder_ids: $albumFolderIds
        slice: { limit: 999 }
        claimed_status_filter: CLAIMED
      ) {
        records {
          id
          album_folder {
            id
          }
          identity {
            id
            ...IdentityDetails
          }
        }
      }
      linked_identities(relation: ALL) {
        records {
          ...IdentityDetails
          purchased_album_folders {
            records {
              id
            }
          }
        }
      }
    }
  }
  ${IdentityDetails}
`;

export const getAccountAlbumFolderSubscribedIdentitiesOptions = {
  options: ({ albumFolderId }) => ({
    variables: {
      albumFolderIds: [albumFolderId],
    },
  }),
  skip: ({ albumFolderId }) => !albumFolderId,
};

export const getAccountAlbumFolderSubscribedIdentities = graphql(
  getAccountAlbumFolderSubscribedIdentitiesQuery,
  getAccountAlbumFolderSubscribedIdentitiesOptions,
);
